import React, { Fragment, useState } from "react";
import "./selling-current-item.styles.scss";
import axios from "axios";
import { DatePickerModal } from "../date-picker-modal/date-picker-modal.component";
import SearchItem from "../search-item/search-item.component";
import { CustomButton } from "../custom-button/custome-button.component";
import EditOffering from "../edit-offering-modal/EditOffering";
import ReactPixel from "react-facebook-pixel";
import { BASE_URL } from "../../Constants/Global";
import { connect } from "react-redux";
import {
  getListingCurrent,
  getOffers,
  postOrders,
  stripeCapture,
} from "../../utils/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SellingCurrentItem = ({
  user,
  shoe,
  appendPendingShoeData,
  setCurrentData,
}) => {
  const { name, detail, coloway, imageUrl, price, id } = shoe;
  const [modalStatus, setModalStatus] = useState(false);
  const [showEditModal, setEditModal] = useState(false);

  const sendShoeToPending = () => {
    appendPendingShoeData(shoe);
  };

  function AcceptOffer() {
    getOffers(shoe.shoe_id, shoe.size, shoe.highest_offer)
      .then((response) => {
        var offer = response;
        var offerData = {
          productID: shoe.shoe_id,
          size: offer.size,
          buyerID: offer.buyer_id,
          sellerID: user.user_id,
          price: offer.totalBill,
          isAuthentic: 0,
          notes: null,
          status: "Pending",
          quiqupJobID: null,
          pickupState: null,
          dropOffstate: null,
          pickupTrackingURL: null,
          dropOffTrackingURL: null,
        };

        stripeCapture({ intentID: response.intentID }).then(
          (captureResponse) => {
            const postOrderData = {
              offerData: offerData,
              listing_id: shoe.listing_id,
              offer_id: offer.offers_id,
              soldTo: offerData.buyerID,
              shipping: parseFloat(offer.shippingFee),
              vat: parseFloat(offer.vat),
              processing: parseFloat(offer.processingFee),
              offerAmount: parseFloat(offer.offerAmount),
            };

            postOrders(postOrderData).then((ordersResponse) => {
              const advancedMatching = { em: "some@email.com" }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
              const options = {
                autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
                debug: true, // enable logs
              };
              ReactPixel.init("3098857153686189", advancedMatching, options);

              ReactPixel.pageView(); // For tracking page view
              ReactPixel.trackSingleCustom(
                "3098857153686189",
                "Purchase",
                offerData
              ); // For tracking custom events.

              getListingCurrent(user.user_id).then((listingResponse) => {
                setCurrentData(listingResponse.data);
              });
            });
          }
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function getWindowDimensions() {
    const { innerWidth: width } = window;
    return width;
  }

  var widthScreen = getWindowDimensions();

  return (
    <div className="selling-current-item-container">
      {widthScreen <= 481 && showEditModal ? (
        <div style={{ transform: "translate(280px, 0)", zIndex: "1" }}>
          <EditOffering
            setEditModal={setEditModal}
            showEditModal={showEditModal}
            selling={true}
            shoe={shoe}
          />
        </div>
      ) : null}
      <div className="item-container">
        <SearchItem shoe={shoe} selling={true} />
      </div>
      <div className="heading-container tier-two">{shoe.size}</div>
      <div className="heading-container tier-two">AED {shoe.askingPrice}</div>
      <div className="heading-container">
        <div>
          AED <span> </span>
          {shoe.highest_offer !== null &&
            parseInt(shoe.highest_offer).toFixed(0)}
          {shoe.highest_offer === null && 0}
        </div>
        <div style={{ alignSelf: "center" }}>
          {widthScreen <= 481
            ? shoe.highest_offer > 0 && (
                <CustomButton
                  onClick={AcceptOffer}
                  style={{ height: "20px" }}
                  size="smallInverted"
                >
                  Accept
                </CustomButton>
              )
            : null}
        </div>
        {widthScreen <= 481 ? (
          <div
            className="editIcon"
            onClick={() => setEditModal(!showEditModal)}
          >
            <FontAwesomeIcon icon={["fa", "edit"]} />
          </div>
        ) : null}
        {/* {widthScreen <= 481 && showEditModal ? (
          <EditOffering
            setEditModal={setEditModal}
            showEditModal={showEditModal}
          />
        ) : null} */}
      </div>

      {widthScreen > 481
        ? shoe.highest_offer > 0 && (
            <CustomButton
              onClick={AcceptOffer}
              style={{ height: "20px", position: "absolute", left: "90%" }}
              size="smallInverted"
            >
              Accept
            </CustomButton>
          )
        : null}

      {widthScreen > 481 ? (
        <div className="editIcon" onClick={() => setEditModal(!showEditModal)}>
          <i className="fas fa-edit"></i>
        </div>
      ) : null}
      {widthScreen > 481 && showEditModal ? (
        <EditOffering
          setEditModal={setEditModal}
          showEditModal={showEditModal}
          selling={true}
          shoe={shoe}
        />
      ) : null}

      <DatePickerModal
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
        sendShoeToPending={sendShoeToPending}
        handleSubmission={true}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SellingCurrentItem);
